export enum RccapLateStageDonorDecline {    
    IncompleteDonorProfile = 0,
    RCenterReversedDecision = 1,
    LineBall = 2,
    DataEntryError = 3
}